import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { SofaButton, SofaPanel } from '@sofology/sofologycomponents';
import { routes } from 'routes';

import './DeliveryDatePage.scss';

import { generateDispatchToPropsMap } from 'helpers/dispatchToPropsGenerator';
import { BasketModal, Loader, OrderSummaryPanel } from 'components';
import { AppState } from 'store';
import { CheckoutDeliverNotBefore } from './index';

import {
    userHelper,
    paymentHelper
} from 'helpers';
import { BasketDetailsModel } from 'models/Basket';
import { DeliverNotBeforeType } from './CheckoutDeliverNotBefore/CheckoutDeliverNotBefore';
import {
    InitCheckoutPageFunc,
    initCheckoutPage,
    PreprocessContinueDeliveryDateFunc,
    preprocessContinueDeliveryDate
} from 'store/checkout/actions';
import { PaymentDetailsModel } from 'models/Payment';
import { setShowReservationWarning, SetShowReservationWarningFunc } from 'store/basket/actions';

interface OwnProps {}

interface StateProps {
    basket: BasketDetailsModel;
    isBasketLoading: boolean;
    paymentDetails: PaymentDetailsModel;
    shouldShowReservationWarning: boolean;
    isUpdatingEca: boolean;
    isContinueFromDeliveryDateProcessing: boolean;
}

interface DispatchProps {
    initCheckoutPage: InitCheckoutPageFunc;
    preprocessContinueDeliveryDate: PreprocessContinueDeliveryDateFunc;
    setShowReservationWarning: SetShowReservationWarningFunc;
}

class DeliveryDatePage extends Component<
StateProps & DispatchProps & OwnProps & RouteComponentProps
> {
    private deliverNotBeforeElement = React.createRef<DeliverNotBeforeType>();

    componentDidMount() {
        this.props.initCheckoutPage();
    }

    handleContinueClick = () => {
        if (this.deliverNotBeforeElement.current?.validate()) {
            this.props.preprocessContinueDeliveryDate(
                () => {
                    paymentHelper.isCardRelatedPaymentType(
                        this.props.paymentDetails.paymentType
                    )
                        ? this.props.history.push(routes.payment.path)
                        : this.props.history.push(
                            routes.dataProtectionNotice.path
                        );
                }
            );
        }
    };

    handleReservationWarningClick = () => {
        this.props.setShowReservationWarning(false);
        this.props.history.push(routes.basket.path);
    };

    render(): JSX.Element {
        const { isBasketLoading, basket, shouldShowReservationWarning } = this.props;

        /** need to check user/access token and redirect to basket */
        if (!userHelper.isUserLoggedIn()) {
            this.props.history.push(routes.basket.path);
        }

        return (
            <div className='delivery-date-page'>
                {isBasketLoading && !basket ? (
                    <Loader show={isBasketLoading} />
                ) : (
                    <>
                        {basket && this.renderSummaryPanel()}
                        <BasketModal open={shouldShowReservationWarning} onClick={this.handleReservationWarningClick} />
                    </>
                )}
            </div>
        );
    }

    renderSummaryPanel(): JSX.Element {
        const { isContinueFromDeliveryDateProcessing, isUpdatingEca } = this.props;

        return (
            <>
                <SofaPanel>
                    <CheckoutDeliverNotBefore
                        ref={this.deliverNotBeforeElement}
                    />
                </SofaPanel>
                <div className='delivery-date-page__actions'>
                    {(isContinueFromDeliveryDateProcessing || isUpdatingEca) && (
                        <Loader show={true} overlay={true} />
                    )}
                    <SofaButton
                        text='Continue'
                        variant='primary'
                        onClick={this.handleContinueClick}
                    />
                </div>
                <OrderSummaryPanel />
            </>
        );
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        basket: state.basketState.basket!,
        isBasketLoading: state.basketState.isBasketLoading,
        paymentDetails: state.paymentState.paymentDetails,
        shouldShowReservationWarning: state.basketState.shouldShowReservationWarning,
        isUpdatingEca: state.checkoutState.isUpdatingEca,
        isContinueFromDeliveryDateProcessing: state.checkoutState.isContinueFromDeliveryDateProcessing
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [
        initCheckoutPage,
        preprocessContinueDeliveryDate,
        setShowReservationWarning
    ]);
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDatePage);
